import { CampaignIndexState } from './reducer';

export const selectCampaignMetrics = (state: { campaignIndex: CampaignIndexState }) =>
  state.campaignIndex.campaignMetrics;
export const selectCampaignMetricsLoading = (state: { campaignIndex: CampaignIndexState }) =>
  state.campaignIndex.loading;
